/**
 * Provides abstraction to do queries.
 * Will build this out as needed.
 **/

const getJson = url => window.fetch(url,
  {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  }
)

/**
 * Filterrific requires the following convention to work:
 * params need to be sent as filterrific[someKey]=someVal
 * corresponding to filterrific = { someKey: someVal }
 */
const generateFilterrificQuery = (appliedFilters, search) => {
  const getBaseParam = filterrificKey => `filterrific[${filterrificKey}][]`
  const res = [
    [`filterrific[search_query]=${encodeURIComponent(search)}`],
    ...appliedFilters.map(({ selectedColumn, selectedValues, selectedPredicate }) =>
      [
        `${getBaseParam(selectedColumn.filterrific_key)}[${'selected_value'}]=${encodeURIComponent(selectedValues.selectedInput)}&${getBaseParam(selectedColumn.filterrific_key)}[${'selected_value_other'}]=${encodeURIComponent(selectedValues.selectedInputOther)}&${getBaseParam(selectedColumn.filterrific_key)}[${'selected_predicate'}]=${selectedPredicate}`

      ]
    )
  ].join('&')
  return res
}

export { getJson, generateFilterrificQuery }
